import React, { useCallback } from "react";
import FilterOption from "../FilterOption";
import SrpContainer from "../../../containers/SrpContainer";
import subscribe from "venuescanner-js/react/helpers/subscribe";
import FiltersContainer from "../FiltersContainer";

export const wrapFilterOption =
  ({
    label,
    title,
    name,
    getValueLabel,
    defaultValue,
    ga,
    checkIfDefault,
    checkIfDirty,
    props: extraProps = {},
    stopUrlRefresh = false,
    hideClearFiltersCta = false,
  }) =>
  (Component) =>
    subscribe({ SrpContainer, FiltersContainer })(
      ({ srpContainer, filtersContainer, zIndex, error, ...props }) => {
        const { query } = srpContainer.state;
        const nextQuery = filtersContainer.state.values;
        const theValue = nextQuery[name] || query[name] || defaultValue;
        const hasChanged = !!nextQuery[name];
        const isDefault = checkIfDefault(theValue);

        const setNewValue = useCallback(
          (theNewValue) => {
            filtersContainer.set({ [name]: theNewValue });
            // console.log({ theNewValue })
            // checkIfDirty(query[name], theNewValue) // && !checkIfDefault(theNewValue)
            //   ? filtersContainer.set({ [name]: theNewValue })
            //   : filtersContainer.unset(name)
          },
          [filtersContainer]
        );
        const update = async (nextValue) => {
          filtersContainer.unset(name);
          await srpContainer.patchQuery({ ...nextValue, page: 1 });
          const fieldsWithErrors = filtersContainer.validate(
            srpContainer.state.query
          );
          if (
            Object.values(fieldsWithErrors).filter(Boolean).length === 0 &&
            !stopUrlRefresh
          ) {
            srpContainer.refresh({ replace: true });
          }
        };

        return (
          <FilterOption
            label={label}
            title={title}
            reset={!isDefault ? () => update({ [name]: undefined }) : undefined}
            apply={
              !isDefault && hasChanged ? () => update(nextQuery) : undefined
            }
            zIndex={zIndex}
            value={
              typeof getValueLabel === "function"
                ? getValueLabel(theValue)
                : theValue
            }
            error={error}
            ga={ga}
            hideClearFiltersCta={hideClearFiltersCta}
          >
            <Component
              value={theValue}
              onChange={setNewValue}
              {...extraProps}
              {...props}
            />
          </FilterOption>
        );
      }
    );

export const sliderFilterOption = ({ defaultValue, ...props }) =>
  wrapFilterOption({
    defaultValue,
    checkIfDefault: (val) =>
      val[0] === defaultValue[0] && val[1] === defaultValue[1],
    checkIfDirty: (oldVal = [], newVal = []) => {
      return (
        (oldVal == null && newVal != null) ||
        oldVal[0] !== newVal[0] ||
        oldVal[1] !== newVal[1]
      );
    },
    ...props,
  });

export const numberFilterOption = ({ defaultValue, ...props }) =>
  wrapFilterOption({
    defaultValue,
    checkIfDefault: (val) => !val,
    checkIfDirty: (_, newVal) => newVal != null,
    ...props,
  });

export const stringFilterOption = ({ defaultValue, ...props }) =>
  wrapFilterOption({
    defaultValue,
    checkIfDefault: (val) => val === defaultValue,
    checkIfDirty: (oldVal, newVal) => oldVal !== newVal,
    ...props,
  });

export const setFilterOption = ({ options, ...props }) =>
  wrapFilterOption({
    checkIfDefault: (val) => !val,
    checkIfDirty(oldVal, newVal) {
      const oldSize = oldVal?.size || 0;
      if (oldSize === 0 && newVal.size === 0) return false;
      if (oldSize !== newVal.size) return true;
      return newVal.size !== oldSize && newVal.some((val) => !oldVal?.has(val));
    },
    ...props,
  });
